enum DocumentType {
  FlowModelSchemaSteps = 1,
  FlowModelSchemaMap = 2,
  FlowModelSchemaMapAndSteps = 3,
  Flow = 4,
  ProcedureSchema = 5,
  FlowModelSchemaParentMapAndSteps = 6
}

export default DocumentType;
